import React,{ useState, useEffect, useContext } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { auth, db, logMe } from '../firebase';
import { useParams } from 'react-router-dom';
import { Avatar, Button, Container } from '@mui/material';
import { green, red } from '@mui/material/colors';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuthState } from 'react-firebase-hooks/auth';
import AlertsContext from '../AlertsContext';

function TicketValidator() {
    const [user, authLoading, error] = useAuthState(auth);
    const [ticket, setTicket] = useState();
    const {purchaseId, ticketId} = useParams();
    const [markedAsUsed, setMarkedAsUsed] = useState(false);
    const { setAlert } = useContext(AlertsContext)

    const ticketRef = doc(db, `ticketPurchases/${purchaseId}/tickets/${ticketId}`)

    async function markAsUsed() {
        // If the ticket is valid, update the ticket status in the database as "used"
        // expired tickets are not updated so we can keep track of them
        await updateDoc(ticketRef, {
            status: "used",
            usedDate: new Date()
        });
        setMarkedAsUsed(true);
        setAlert("Ticket marked");
    }

    useEffect(() => {
        // get purchase info
        logMe('ticketValidator', {purchaseId, ticketId});
        getDoc(ticketRef).then((doc) => {
            if (doc.exists()) {
                console.log("Document data:", doc.data());
                const data = doc.data();

                // check if startDate is before today and status is not used
                const now = new Date().getTime();
                const startDate = data.startDate.toDate().getTime();
                // give 24h grace period for tickets in case they bought them on the same day
                const isNotExpired = (startDate + 24*60*60*1000) > now;
                const isNotUsed =  data.status !== "used";
                const isValid = isNotExpired && isNotUsed;

                setTicket({
                    ...data,
                    isValid,
                    validationStatus: !isNotExpired ? "EXPIRED" : (isNotUsed ? "VALID" : "USED")
                })

            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        });

    }, []);

    const iconSize = { width: 100, height: 100}

    return ticket && (
        <Container maxWidth="sm" style={{textAlign: 'center', paddingTop: '20px'}}>
            <Avatar sx={{ width: 100, height: 100, textAlign: 'center', margin: '0 auto', bgcolor: ticket.isValid ? green[500] : red[500] }}>
                {ticket.isValid ? <CheckCircleIcon sx={iconSize} /> : <CancelIcon sx={iconSize} />}
            </Avatar>
            <h1>Ticket {ticket.validationStatus}</h1>
            <h1>{ticket.title}</h1>
            <h2>{ticket.ticketLocation.toUpperCase()}</h2>

            {user && ticket.isValid && !markedAsUsed && <Button variant="outlined" onClick={() => markAsUsed()}>
                Mark as used
            </Button>}
        </Container>
    );
}

export default TicketValidator;